module.exports = __webpack_public_path__ + "static/btn-playstore-01f358af24ca3e599f9b5f2d17d9d53e.svg";